module.exports = __webpack_public_path__ + "img/6.31ccfe46.jpg";